import { selectBrandWhiteLabelError } from '../stores/brand';
import GET_PARTNER_DETAILS_QUERY from '../queries/partner/getPartner.graphql';

const brandLoader = async (dispatch, partnerName, state, apolloClient) => {
  const error = selectBrandWhiteLabelError(state);

  if (error) {
    throw new Response('Not found', {
      status: 404
    });
  }

  const data = await apolloClient.query({
    query: GET_PARTNER_DETAILS_QUERY,
    variables: {
      partnerName
    }
  });

  return data?.data?.partner;
};

export default brandLoader;
